import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_list",
  "use": "icon-icon_list-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_list\">\n<path d=\"M2 4V5H2.5H3V7.5V8H4V7.5V4H2.5H2ZM7 5V7H22V5H7ZM2 10V11H2.5H3.79297L2 12.793V14H4.5H5V13H4.5H3.20703L5 11.207V10H2.5H2ZM7 11V13H22V11H7ZM2 16V17H2.5H4V17.5H3.5H3V18.5H3.5H4V19H2.5H2V20H2.5H5V18.5V17.5V16H2.5H2ZM7 17V19H22V17H7Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol